import styled from "styled-components"

export const Section = styled.section`
  margin: 5rem 0;
`

export const Wrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: 1200px;
`

export const Paragraph = styled.p`
  max-width: 750px;
  margin: 1rem 0;
  a {
    color: var(--red);
  }
`
